module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/ceo-qianzong.3ce2aaad.jpg";